'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageRequest() {
}
export { $c_Lapp_data_AppDocumentLineageRequest as $c_Lapp_data_AppDocumentLineageRequest };
$p = $c_Lapp_data_AppDocumentLineageRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentLineageRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageRequest() {
}
export { $h_Lapp_data_AppDocumentLineageRequest as $h_Lapp_data_AppDocumentLineageRequest };
$h_Lapp_data_AppDocumentLineageRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_data_AppDocumentLineageRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fQ)));
}
export { $isArrayOf_Lapp_data_AppDocumentLineageRequest as $isArrayOf_Lapp_data_AppDocumentLineageRequest };
//# sourceMappingURL=app.data.-App-Document-Lineage-Request.js.map
